<template>
  <div class="container-page">
    <div>
      <p class="title-inner">Карточка правового источника</p>
    </div>
    <div>
      <div class="form-group required">
        <ComponentInput
          v-model="card.name"
          label="Название"
          required
          :maxLength="1000"
          placeholder="Введите название"
        />
      </div>
      <div class="form-group">
        <label class="form-label">Файл</label>
        <FileUpload width="100%" :entity="card" @deleteFile="removeFile" propName="file" @uploaded="fileUploaded" />
      </div>
      <div class="form-group required">
        <ComponentInput
          label="Тип НПА"
          :select2Settings="select2Settings"
          :select2Options="legalActTypes"
          v-model="card.legalActTypeId"
          required
          type="select2"
        />
      </div>
      <div class="form-group">
        <ComponentInput
          v-model="card.legalPortalLink"
          label="Ссылка на правовой портал"
          :maxLength="1000"
          placeholder="Введите ссылку на правовой портал"
          :error="v$.card.legalPortalLink?.$error"
          :errorMessage="absoluteUrlErrorMessage"
        />
      </div>
      <div class="form-group mt-10">
        <CheckboxInput v-model="card.isActive" label="Запись активна" />
      </div>
    </div>
    <div class="mb-16">
      <ButtonComponent mod="gradient-bg" class="mr-8" @click="save">Сохранить</ButtonComponent>
      <ButtonComponent mod="border" @click="close">Отмена</ButtonComponent>
    </div>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex';
  import { useVuelidate } from '@vuelidate/core';

  import ComponentInput from '@/common/components/ComponentInput.vue';
  import FileUpload from '@/common/components/FileUpload.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import CheckboxInput from '@/common/components/redesigned/CheckboxInput.vue';
  import Constants from '@/common/constants';
  import Utils from '@/common/utils';
  import { isEmptyOrSafeHttpUrl, SAFE_HTTP_URL_ERROR_MESSAGE } from '@/common/utils/url';

  import API from '../../navigator/api/legalsource';
  import NsiApi from '../../nsi/api/nsi';
  import { NAVIGATOR_STEP_CARD_MUTATIONS_NAME } from '../store/stepCards';

  export default {
    name: 'LegalSourceCard',
    components: { CheckboxInput, FileUpload, ButtonComponent, ComponentInput },
    data() {
      return {
        id: this.$route.params.id,
        redirectURL: this.$route.query.redirectURL,
        card: {},
        legalActTypes: [],
        select2Settings: Constants.select2Settings,
        isSavedDraftCard: false,
      };
    },
    created() {
      this.loadDictionaries();
      this.loadCard();
    },
    unmounted() {
      if (!this.isSaveDraftCard) {
        this.setDraftStepCard(null);
      }
    },
    computed: {
      absoluteUrlErrorMessage() {
        return SAFE_HTTP_URL_ERROR_MESSAGE;
      },
    },
    methods: {
      ...mapMutations({
        setDraftStepCard: NAVIGATOR_STEP_CARD_MUTATIONS_NAME.setDraftStepCard,
      }),
      loadCard() {
        if (this.id > 0) {
          API.find(this.id).then((response) => {
            this.card = response.data;
          });
        }
      },
      loadDictionaries() {
        NsiApi.search('nsilegalacttype', { pageNumber: 1, pageSize: 0, isActive: true })
          .then((response) => {
            const list = response.data.items.map((x) => ({
              name: x.name,
              id: x.id,
              parentId: x.parentId,
              parentName: x.parent?.name,
              isLeaf: x.id === 1,
            }));
            this.legalActTypes = Utils.groupList(list, (x) => ({ id: x.parentId ?? 0, text: x.parentName ?? '' }));
          })
          .catch((error) => {
            console.error(error?.response?.data);
          });
      },
      async save() {
        try {
          this.v$.$touch();
          if (this.v$.$invalid) {
            Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
            return;
          }

          const result = await API.update(this.card);

          Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');

          if (this.redirectURL) {
            this.isSavedDraftCard = true;

            let newLegalSourceId;

            if (result.data.isActive) newLegalSourceId = result.data.id;

            this.$router.push({ path: this.redirectURL, query: { newLegalSourceId } });
            return;
          }

          if (this.card.id) {
            this.$router.push({ name: 'LegalSourceCard', params: { id: this.card.id, action: 'edit' } });
          } else {
            this.$router.push({ name: 'LegalSources' });
          }
        } catch (e) {
          Constants.alert.fire('Сохранение', Constants.commonError, 'error');
        }
      },
      fileUploaded(e) {
        this.card.file = e.data;
        this.card.fileId = e.data ? e.data.id : null;
      },
      removeFile() {
        this.card.file = {};
        this.card.fileId = null;
      },
      close() {
        if (this.redirectURL) {
          this.isSavedDraftCard = true;
          this.$router.push(this.redirectURL);
          return;
        }

        this.$router.push({ name: 'LegalSources' });
      },
    },
    setup: () => ({ v$: useVuelidate() }),
    validations() {
      return {
        card: {
          legalPortalLink: { absoluteUrl: isEmptyOrSafeHttpUrl },
        },
      };
    },
  };
</script>

<style lang="scss" scoped>
  .form-label {
    font-weight: 400 !important;
    font-size: 14px;
    color: #231f20;
    line-height: 160%;
  }
</style>
